import { render, staticRenderFns } from "./inventoryByProduct.vue?vue&type=template&id=54a78f18&"
import script from "./inventoryByProduct.vue?vue&type=script&lang=js&"
export * from "./inventoryByProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports